const Commander = (()=>{
    const o = {
        SavePassword : async ( url, uri, headers, fetchApi, info ) => {
            //Commander.run('SavePassword', url, headers, fetchApi, info)
            const res = await fetchApi({
              method: "POST",
              url: url + uri,
              headers: headers,
              content: info,
            });
            return  res;
        }
    }

    return {
        run : ( command, parameter1, parameter2, parameter3, parameter4, parameter5 ) => {
            if(!o[command]){
                console.log('el comando no existe');
                return;
            }
            return o[command](parameter1, parameter2, parameter3, parameter4, parameter5);
        },
    }
})()

export default Commander